module.exports = __webpack_public_path__ + "img/1.fd8e3e7d.jpeg";